var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconReadHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.251v1a.905.905 0 0 0 .589.887l6.911 2.113v-8.833l-6.473-2.373A.817.817 0 0 0 5 12.919v1.844M20.013 19.1v1.157a.9.9 0 0 1-.588.887L12.5 23.251v-8.833l6.486-2.373a.817.817 0 0 1 1.027.874v1.988",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.487 18.358c0 .5-.563.9-1.251.893-1.378-.006-2.491-.816-2.486-1.81v-.9c0-.993 1.125-1.793 2.5-1.787.689 0 1.245.408 1.243.9Zm11.27 0c0 .5.563.9 1.253.893 1.38-.006 2.495-.816 2.49-1.81v-.9c0-.993-1.127-1.793-2.507-1.787-.689 0-1.247.408-1.244.9ZM8.387 4.876a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 1 0-8.25 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconReadHuman);
export default __webpack_public_path__ + "static/media/streamline-icon-read-human.4d8d0a19.svg";
export { ForwardRef as ReactComponent };